import Cookies from 'js-cookie';
import { setRolexConsent } from 'src/lib/rolex_cookies';
import { adobeTrack } from 'src/lib/adobe_track';
import { callGtag } from 'src/lib/gtag';

// if cmp is undefined, then they need to be asked
// the value of CMP contains a comma delim string
// of which cookies they allow (whitelist), options are:
// analytics
// rolex
const askCookieName = '_cmp';

const setCmpCookie = (accepted) => {
  Cookies.set(askCookieName, accepted.join(','), { expires: 365 });

  // rolex adobe tracking consent
  if (accepted.includes('rolex')) {
    setRolexConsent('true');

    // Rolex doc says to call this on affirmative:
    // ("Updated CMP user guide - Bespoke.pdf" - 2023-03-21)
    adobeTrack('popinactionconsent');
  } else {
    setRolexConsent('false');
  }

  // google analytics consent
  if (accepted.includes('analytics')) {
    callGtag('consent', 'update', { analytics_storage: 'granted' });
  } else {
    callGtag('consent', 'update', { analytics_storage: 'denied' });
  }
};

const needsToBeAsked = () => {
  const result = Cookies.get(askCookieName) === undefined;
  return result;
};

// Answers. If all is set to bool:true it overrides the other options
const accepts = ({ all = false, analytics = false, rolex = false }) => {
  const accepted = [];

  if (all) {
    accepted.push('analytics', 'rolex');
  }

  if (analytics) {
    accepted.push('analytics');
  }

  if (rolex) {
    accepted.push('rolex');
  }

  setCmpCookie(accepted);
};

const rejectsAll = () => {
  setCmpCookie([]);
};

export {
  needsToBeAsked,
  accepts,
  rejectsAll,
};
